// extracted by mini-css-extract-plugin
module.exports = {"root":"IconsNav_root__1KdLD","icons":"IconsNav_icons__3pdNU","headerNav":"IconsNav_headerNav__2SJPt"};